import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
const messages = defineMessages({
  save: {
    id: 'App.LeaseDataTabForm.LeaseActionButtons.ButtonStates.SaveLabel',
    defaultMessage: 'Save',
  },
  edit: {
    id: 'App.LeaseDataTabForm.LeaseActionButtons.ButtonStates.Edit',
    defaultMessage: 'Edit',
  },
  uploadSignedLease: {
    id: 'App.LeaseDataTabForm.LeaseActionButtons.ButtonStates.UploadSignedLease',
    defaultMessage: 'Upload Signed Lease',
  },
  downloadLease: {
    id: 'App.LeaseDataTabForm.LeaseActionButtons.ButtonStates.DownloadLeaseLabel',
    defaultMessage: 'Download Lease',
  },
  confirmEditLease: {
    id: 'App.LeaseDataTabForm.LeaseActionButtons.ButtonStates.ConfirmEditLease',
    defaultMessage:
      'Editing the Lease Data Tab will render any previously downloaded lease and signatures invalid. Are you sure you want to continue?',
  },
  cancel: {
    id: 'App.LeaseDataTabForm.UploadLeaseModal.ButtonStates.Cancel',
    defaultMessage: 'Cancel',
  },
  sendToPortal: {
    id: 'App.LeaseDataTabForm.UploadLeaseModal.ButtonStates.SendToPortal',
    defaultMessage: 'Send to Portal',
  },
  sentToPortal: {
    id: 'App.LeaseDataTabForm.UploadLeaseModal.ButtonStates.SentToPortal',
    defaultMessage: 'Lease sent to Portal',
  },
  executeLease: {
    id: 'App.LeaseDataTabForm.UploadLeaseModal.ButtonStates.ExecuteLease',
    defaultMessage: 'Execute Lease',
  },
  electronicallyExecuted: {
    id: 'App.LeaseDataTabForm.UploadLeaseModal.ButtonStates.ElectronicallyExecuted',
    defaultMessage: 'Lease electronically executed',
  },
  signedLeaseUploaded: {
    id: 'App.LeaseDataTabForm.UploadLeaseModal.ButtonStates.SignedLeaseUploaded',
    defaultMessage: 'Signed lease has been uploaded to the Documents Tab',
  },
  confirmEditLeaseProviderUnknown: {
    id: 'App.LeaseDataTabForm.LeaseActionButtons.ButtonStates.ConfirmEditLeaseProviderUnknown',
    defaultMessage:
      'Editing the Lease Data Tab may remove the lease from Portal and remove any signatures. Are you sure you want to continue?',
  },
  confirmEditElectronicLease: {
    id: 'App.LeaseDataTabForm.UploadLeaseModal.ButtonStates.ConfirmEditElectronicLease',
    defaultMessage:
      'Editing the Lease Data Tab will remove the lease from Portal and remove any signatures. Are you sure you want to continue?',
  },
  warning: {
    id: 'App.LeaseDataTabForm.UploadLeaseModal.ButtonStates.Warning',
    defaultMessage: 'WARNING',
  },
  cancelElectronic: {
    id: 'App.LeaseDataTabForm.UploadLeaseModal.ButtonStates.CancelElectronic',
    defaultMessage:
      'Cancelling the executed Lease will remove the lease from Portal and the Documents Tab and render the previously executed lease and signatures invalid.',
  },
  cancelManual: {
    id: 'App.LeaseDataTabForm.UploadLeaseModal.ButtonStates.CancelManual',
    defaultMessage:
      'Cancelling the executed Lease will render the previously executed lease and signatures invalid, and remove the lease from the Documents Tab.',
  },
  areYouSure: {
    id: 'App.LeaseDataTabForm.UploadLeaseModal.ButtonStates.AreYouSure',
    defaultMessage: 'Are you sure you want to continue?',
  },
  notReconciled: {
    id: 'App.LeaseDataTabForm.UploadLeaseModal.ButtonStates.NotReconciled',
    defaultMessage:
      'Monthly Lease Charges have not been reconciled. Click "Edit" to unlock the Lease Data tab, add all monthly charges, and click save to continue.',
  },
  notApproved: {
    id: 'App.LeaseDataTabForm.UploadLeaseModal.ButtonStates.NotApproved',
    defaultMessage:
      'The compliance approval status must be Approved or Approved Pending Signatures in order to generate the lease.',
  },
  // The transfer-certification gate names the blocked program(s) — any program on the transfer,
  // not just HUD/RD. Singular "certification" however many `programs` interpolates to — that is
  // ENG-31662's verbatim wording.
  transferCertNotApproved: {
    id: 'App.LeaseDataTabForm.LeaseActionButtons.ButtonStates.TransferCertNotApproved',
    defaultMessage:
      'There is an open {programs} transfer certification that must be approved before you can execute the lease.',
  },
  // The affordable compliance-approval gate names the unapproved program(s) too. It has no
  // "transfer" in the wording because it fires on the applicant / move-in / first-lease flow.
  certificationsNotApproved: {
    id: 'App.LeaseDataTabForm.LeaseActionButtons.ButtonStates.CertificationsNotApproved',
    defaultMessage:
      'There is an open {programs} certification that must be approved before you can execute the lease.',
  },
  // Fallback for the shape where the gate says blocked but no program name could be resolved —
  // without it the copy above would render "There is an open  certification".
  certificationsNotApprovedGeneric: {
    id: 'App.LeaseDataTabForm.LeaseActionButtons.ButtonStates.CertificationsNotApprovedGeneric',
    defaultMessage:
      'You cannot perform this action until all applicable certifications are Approved.',
  },
  generateInBlueMoon: {
    id: 'App.LeaseDataTabForm.LeaseActionButtons.ButtonStates.GenerateInBlueMoon',
    defaultMessage: 'Generate Lease in Blue Moon',
  },
  blueMoonGenerateHelper: {
    id: 'App.LeaseDataTabForm.LeaseActionButtons.ButtonStates.BlueMoonGenerateHelper',
    defaultMessage:
      'Generate Lease in Blue Moon creates the lease in Blue Moon from the saved lease data. Signing happens in Blue Moon.',
  },
  blueMoonDownloadPending: {
    id: 'App.LeaseDataTabForm.LeaseActionButtons.ButtonStates.BlueMoonDownloadPending',
    defaultMessage:
      'Download Lease is available after the Blue Moon packet is generated.',
  },
  blueMoonGeneratePending: {
    id: 'App.LeaseDataTabForm.LeaseActionButtons.ButtonStates.BlueMoonGeneratePending',
    defaultMessage: 'Generating the lease in Blue Moon is not available yet.',
  },
  blueMoonUnavailable: {
    id: 'App.LeaseDataTabForm.LeaseActionButtons.ButtonStates.BlueMoonUnavailable',
    defaultMessage:
      'Blue Moon is unavailable. Your saved lease has been kept. Contact Support or check the connection before continuing.',
  },
  providerUnknown: {
    id: 'App.LeaseDataTabForm.LeaseActionButtons.ButtonStates.ProviderUnknown',
    defaultMessage:
      'The lease signing provider could not be determined. Try again or contact Support.',
  },
});

export default messages;
